angular.module('nv.singleStudent').component('ssvPanelStatusWidget', {
  template: require('./ssv-panel-status-widget.html'),
  controller: 'ssvPanelStatusWidgetCtrl',
});
